// App.js
import React, { useRef, useEffect } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ScrollToTop from "./helper/ScrollToTop";
import { GlobalStyle } from "./components/common/styles/global.js";
import HomeOne from "./HomeOne";
import HomeTwo from "./HomeTwo";
import About from "./pages/about/About";
import CourseGrid from "./pages/courses/CourseGrid";
import CourseList from "./pages/courses/CourseList";
import CourseDetails from "./pages/courses/CourseDetails";
import Instructor from "./pages/instructor/Instructors";
import InstructorDetails from "./pages/instructor/InstructorDetails";
import Gallery from "./pages/gallery/Gallery";
import Events from "./pages/events/Events";
import EventDetails from "./pages/events/EventsDetails";
import Login from "./pages/account/Login";
import Register from "./pages/account/Register";
import Contact from "./pages/contact/Contact";
import Faq from "./pages/faq/Faq";
import PageNotFound from "./pages/404/PageNotFound";
import ComingSoon from "./pages/comingsoon/ComingSoon";
import BlogClassic from "./pages/blog/BlogClassic";
import BlogGrid from "./pages/blog/BlogGrid";
import BlogDetails from "./pages/blog/BlogDetails";
import Product from "./pages/shop/Products";
import ProductDetails from "./pages/shop/ProductDetails";
import Cart from "./pages/shop/Cart";
import ExamGrid from "./pages/courses/ExamsGrid.js";
import ExamDetails from "./pages/courses/ExamDetails.js";

import DemoBookingModal from "./components/common/DemoBookingModal.js"; // Modal component
import AbacusOnlineClasses from "./components/AbacusOnline.js";
import AbacusNearMe from "./components/AbacusNearMe.js";
import AbacusForSchools from "./components/AbacusSchool.js";
import FranchiseEnquiry from "./components/FranchiseEnquiry.js";
import ContactUs from "./components/ContactUs.js";

function App() {
  const modalRef = useRef(null);

  // Expose a safe global fallback to open the modal from anywhere (optional)
  useEffect(() => {
    // only set if window exists (browser)
    if (typeof window !== "undefined") {
      window.openDemoModal = (prefill = {}) => {
        if (modalRef.current && typeof modalRef.current.open === "function") {
          modalRef.current.open(prefill);
        } else {
          console.warn("Demo modal ref not ready");
        }
      };

      // cleanup on unmount
      return () => {
        try {
          if (window.openDemoModal) delete window.openDemoModal;
        } catch (e) {
          // ignore (some environments may be strict)
        }
      };
    }
    // If no window, nothing to do
    return undefined;
  }, []);

  const openDemoModal = (prefill = {}) => {
    if (modalRef.current && typeof modalRef.current.open === "function") {
      modalRef.current.open(prefill);
    } else if (
      typeof window !== "undefined" &&
      typeof window.openDemoModal === "function"
    ) {
      // fallback (should normally be the same)
      window.openDemoModal(prefill);
    } else {
      console.warn("Demo modal not available yet");
    }
  };

  return (
    <Router>
      <GlobalStyle />
      <ScrollToTop />

      {/* Global modal (available on every page) */}
      <DemoBookingModal ref={modalRef} />

      {/* Your routes */}
      <Switch>
        <Route
          exact
          path={`${process.env.PUBLIC_URL + "/"}`}
          component={HomeOne}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/home-two"}`}
          component={HomeTwo}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/about"}`}
          component={About}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/course-grid"}`}
          component={CourseGrid}
        />
         <Route
          path={`${process.env.PUBLIC_URL + "/franchise-enquiry"}`}
          component={FranchiseEnquiry}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/abacus-online"}`}
          component={AbacusOnlineClasses}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/abacus-near"}`}
          component={AbacusNearMe}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/abacus-school"}`}
          component={AbacusForSchools}
        />
        {/* <Route path={`${process.env.PUBLIC_URL + "/course-list"}`} component={CourseList} /> */}
        <Route
          path={`${process.env.PUBLIC_URL + "/course-details"}`}
          component={CourseDetails}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/exams-list"}`}
          component={ExamGrid}
        />
        {/* <Route path={`${process.env.PUBLIC_URL + "/course-list"}`} component={CourseList} /> */}
        <Route
          path={`${process.env.PUBLIC_URL + "/exam-details"}`}
          component={ExamDetails}
        />
        {/* <Route path={`${process.env.PUBLIC_URL + "/instructor"}`} component={Instructor} /> */}
        {/* <Route path={`${process.env.PUBLIC_URL + "/instructor-details"}`} component={InstructorDetails} /> */}
        <Route
          path={`${process.env.PUBLIC_URL + "/gallery"}`}
          component={Gallery}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/events"}`}
          component={Events}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/event-details"}`}
          component={EventDetails}
        />
        {/* <Route path={`${process.env.PUBLIC_URL + "/login"}`} component={Login} />
        <Route path={`${process.env.PUBLIC_URL + "/registration"}`} component={Register} />
        <Route path={`${process.env.PUBLIC_URL + "/contact"}`} component={Contact} />
        <Route path={`${process.env.PUBLIC_URL + "/faq"}`} component={Faq} />
        <Route path={`${process.env.PUBLIC_URL + "/404"}`} component={PageNotFound} />
        <Route path={`${process.env.PUBLIC_URL + "/coming-soon"}`} component={ComingSoon} /> */}
        {/* <Route path={`${process.env.PUBLIC_URL + "/blog-classic"}`} component={BlogClassic} /> */}
        <Route
          path={`${process.env.PUBLIC_URL + "/blogs"}`}
          component={BlogGrid}
        />
        <Route
          path={`${process.env.PUBLIC_URL + "/blog-details"}`}
          component={BlogDetails}
        />

         <Route
          path={`${process.env.PUBLIC_URL + "/contact"}`}
          component={ContactUs}
        />


        {/* <Route path={`${process.env.PUBLIC_URL + "/products"}`} component={Product} />
        <Route path={`${process.env.PUBLIC_URL + "/product-details"}`} component={ProductDetails} />
        <Route path={`${process.env.PUBLIC_URL + "/cart"}`} component={Cart} /> */}
      </Switch>

      {/* Floating button — outside <Switch> so it is visible on every route */}
      <button
        onClick={() => openDemoModal()}
        aria-label="Book A Demo Call"
        style={{
          position: "fixed",
          right: 20,
          bottom: 80,
          zIndex: 9999,
          background: "#ff6f6f",
          color: "#fff",
          padding: "18px 32px",
          borderRadius: 12,
          fontWeight: 700,
          fontSize: "18px",
          textDecoration: "none",
          boxShadow: "0 10px 28px rgba(0,0,0,0.18)",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          border: "none",
        }}
      >
        Book A Demo Call
      </button>
    </Router>
  );
}

export default App;
